import styled from 'styled-components';

export const FormWrapper = styled.form`
    display: block;
    max-width: 335px;
    margin: ${props => props.theme?.loginRegisterForm?.wrapper?.margin ?? '1.5em auto 0'};
    overflow: visible;
`;
